// Safari tips
export const safariTips = [
  '🦁 Did you know? Tanzania is home to the Serengeti, one of the world\'s most famous wildlife reserves!',
  '💧 Travel Tip: Always carry a reusable water bottle to stay hydrated on your adventures.',
  '🌅 Safari Wisdom: The best time to spot wildlife is early morning or late afternoon.',
  '🐃 Fun Fact: The Great Migration involves over 1.5 million wildebeest crossing the Serengeti!',
  '📸 Pack light, but don\'t forget your camera—memories are priceless!',
  '🔭 Tip: Bring binoculars for the best wildlife viewing.',
  '🧢 Tip: Wear neutral colors to blend in with the environment.',
  '🦓 Always listen to your guide for safety.',
  '🎥 Keep your camera ready for unexpected moments.',
  '🦒 New: Giraffes only sleep for about 30 minutes a day—keep your eyes peeled for these gentle giants!',
  '🦏 Rhino Fact: Rhinos can run up to 50 km/h—don\'t try to race them!',
  '🦩 Did you know? Lake Natron in Tanzania is home to millions of flamingos!',
  '🐘 Elephant Wisdom: Elephants are highly social and have incredible memories.',
  '🦜 Birdwatch: Over 1,100 bird species can be spotted in Tanzania!',
  '🦴 Fossil Find: Olduvai Gorge is called the "Cradle of Mankind" for its ancient fossils.',
  '🌄 Sunrise Magic: Early morning game drives offer the best light for photos.',
  '🦅 Eagle Eye: Look up! Many raptors soar above the savanna.',
  '🦟 Bug Off: Don\'t forget your insect repellent for a comfortable safari.',
  '🌳 Baobab Fact: Baobab trees can live for over 1,000 years!',
  '🦒 Tall Order: Giraffes are the world\'s tallest mammals—up to 6 meters high!'
];

// Trip-related empty state messages
export const tripEmptyMessages = [
  'No trips on the horizon yet!',
  'The road is clear - no trips scheduled!',
  'Our vehicles are ready but no trips planned!',
  'The journey begins when you create your first trip!',
  'Time to hit the road with some new trips!',
];

// Connection error messages
export const connectionErrorMessages = [
  'Looks like the elephants stepped on our internet cable!',
  'Our safari guides are having trouble finding the server...',
  'The zebras are blocking our connection to the wilderness!',
  "Even our GPS can't locate the server right now...",
  'The safari network is taking a water break!',
];

// Safari-related empty state messages
export const safariEmptyMessages = [
  'No safaris available at the moment!',
  'The wilderness is quiet - no safaris scheduled!',
  'Our guides are ready but no safaris planned!',
  'The adventure begins when you book your first safari!',
  'Time to explore the wild with some new safaris!',
];

// General empty state messages
export const generalEmptyMessages = [
  'Nothing to see here yet!',
  'The page is empty - no content available!',
  'Our team is ready but no content planned!',
  'The journey begins when you add your first item!',
  'Time to get started with some new content!',
];

// Helper function to get random message from an array
export const getRandomMessage = (messages: string[]): string => {
  return messages[Math.floor(Math.random() * messages.length)];
}; 